// extracted by mini-css-extract-plugin
export default {"footerDiv":"Footer_footerDiv__HXogU","footerLink":"Footer_footerLink__Gp5u3"};